import { render } from "./PurchaseAllReports.vue?vue&type=template&id=1b367e75&scoped=true"
import script from "./PurchaseAllReports.vue?vue&type=script&lang=js"
export * from "./PurchaseAllReports.vue?vue&type=script&lang=js"

import "./PurchaseAllReports.vue?vue&type=style&index=0&id=1b367e75&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b367e75"]])

export default __exports__